import React, { ReactNode } from 'react';
import styled, { keyframes } from 'styled-components/macro';
import cx from 'classnames';
import { PlaceholderLine, Line } from './PlaceholderLine';
import { PlaceholderImage, Image } from './PlaceholderImage';

type Props = {
  className?: string;
  column?: boolean;
  children?: ReactNode;
};

const linear = keyframes`
  from {
    background-position: -468px 0;
  }
  to {
    background-position: 600px 0;
  }
`;

export const Placeholder = (props: Props) => {
  const { children, className, column } = props;
  return (
    <PlaceholderWrapper className={cx('man-ui placeholder', className)} column={column}>
      {children}
    </PlaceholderWrapper>
  );
};

const PlaceholderWrapper = styled.div<Props>`
  display: flex;
  width: 100%;
  flex-direction: ${(props) => (props.column ? 'column' : 'row')};

  & ${Line}, ${Image} {
    background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
    background-size: 1200px 100%;
    animation: ${linear} 1s linear forwards infinite;
  }

  & ${Line} {
    margin: 4px 0;

    :first-child {
      margin: 0 0 4px 0;
    }

    :last-child {
      margin: 4px 0 0 0;
    }
  }
`;

Placeholder.Line = PlaceholderLine;
Placeholder.Image = PlaceholderImage;
